module.exports = __webpack_public_path__ + "static/ss_repo-c5ab42fff03ee2d119f6049dda3eedbc.png";